import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';

const stats = [
  { value: '1 200+', label: 'Empresas confiam na NeoDrive', sub: 'Em toda a Europa' },
  { value: '85 000+', label: 'Membros de equipa geridos', sub: 'Estafetas e motoristas por semana' },
  { value: '+4,2 M€', label: 'Processados por semana', sub: 'Em pagamentos automatizados' },
  { value: '99,9%', label: 'Disponibilidade da plataforma', sub: 'Infraestrutura fiável' },
];

export default function Stats() {
  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
        borderBottom: '1px solid #e2e8f0',
        py: { xs: 5, md: 6 },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          {stats.map((stat, i) => (
            <Grid item xs={6} md={3} key={i}>
              <Box
                sx={{
                  textAlign: 'center',
                  px: 2,
                  position: 'relative',
                  '&:not(:last-child)::after': {
                    content: '""',
                    position: 'absolute',
                    right: 0,
                    top: '15%',
                    height: '70%',
                    width: 1,
                    background: '#e2e8f0',
                    display: { xs: 'none', md: 'block' },
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: '1.8rem', md: '2.4rem' },
                    fontWeight: 800,
                    letterSpacing: '-0.03em',
                    background: i % 2 === 0
                      ? 'linear-gradient(135deg, #16a34a, #15803d)'
                      : 'linear-gradient(135deg, #ea580c, #c2410c)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    mb: 0.5,
                  }}
                >
                  {stat.value}
                </Typography>
                <Typography sx={{ fontWeight: 600, fontSize: '0.875rem', color: '#0f172a', mb: 0.3 }}>
                  {stat.label}
                </Typography>
                <Typography sx={{ fontSize: '0.75rem', color: '#94a3b8' }}>
                  {stat.sub}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
